
import { mapActions, mapGetters } from "vuex";
import { yearBrackets } from "@/cars/utils";
import { defineComponent } from "vue";
import { Optional } from "@/globalTypes";
import { Car, CarType, Manufacture, Serie } from "@/cars/types";

interface SelectByTypeData {
  selectedManufacture: Optional<Number>;
  selectedSeries: Optional<Number>;
  selectedType: Optional<Number>;
  series: Array<Serie>;
  types: Array<CarType>;
}

export default defineComponent({
  props: {
    addingNext: Boolean,
  },
  data(): SelectByTypeData {
    return {
      selectedManufacture: null,
      selectedSeries: null,
      selectedType: null,
      series: [],
      types: [],
    };
  },
  mounted() {
    this.pullManufacturers();
  },
  computed: {
    ...mapGetters("cars", ["getManufacturers"]),
  },
  methods: {
    ...mapActions("cars", ["pullManufacturers", "pullSeries", "pullTypes"]),
    toggleVinSelect() {
      this.$emit("toggleVinSelect");
    },
    serieOptionName(serie: Serie) {
      return `${serie.rangeName}${yearBrackets(serie.yearFrom, serie.yearTo)}`;
    },
    selectCar() {
      const manufactureName = this.getManufacturers.find(
        (m: Manufacture) => m.id === this.selectedManufacture
      )?.name;

      const serie = this.series.find((s) => s.rangeId === this.selectedSeries)!;
      const type = this.types.find((t) => t.typeId === this.selectedType)!;
      const car: Car = {
        typeId: this.selectedType!,
        makeName: manufactureName,
        rangeName: serie.rangeName,
        typeName: type.typeName,
        yearFrom: type.yearFrom,
        yearTo: type.yearTo,
        ccm: type.ccm,
        construction: type.construction,
        engine: type.engine,
        kw: type.kw,
        fuel: type.fuel,
      };
      this.selectedManufacture = null;
      this.clearSeries();
      this.$emit("carAdded", car);
    },
    typeOptionName(type: CarType) {
      return `${type.typeName} [${type.kw} kW] (${type.fuel})${yearBrackets(
        type.yearFrom,
        type.yearTo
      )}`;
    },
    clearSeries() {
      this.selectedSeries = null;
      this.series = [];
    },
    clearTypes() {
      this.selectedType = null;
      this.types = [];
    },
  },
  watch: {
    selectedManufacture(manufactureId: Optional<Number>) {
      if (!manufactureId) return;
      this.clearSeries();
      this.pullSeries(manufactureId).then((series: Array<Serie>) => {
        this.series = series;
      });
    },
    selectedSeries(serieId: Optional<Number>) {
      if (!serieId) return;
      this.clearTypes();
      this.pullTypes({ manufactureId: this.selectedManufacture, serieId }).then(
        (types: Array<CarType>) => {
          this.types = types;
        }
      );
    },
  },
});
